import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoadingOverlay from "../../UIComponents/LoadingOverlay.tsx";
import { useAppContext } from "../../context/AppContext.tsx";
import { AuthContext } from "../../context/AuthContext.js";
import RoleGroupEditor from "./RoleGroupEditor.tsx";
import RoleGroupsManager from "./RoleGroupsManager.tsx";
import { RoleGroup } from "./_core/_model.ts";
import { LabelConstants } from "../../Constants.ts";

export function RoleGroupWrapper() {
    const [searchParams] = useSearchParams();
    const [selectedRow, setSelectedRow] = useState<RoleGroup>();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { allRoleGroups } = useAppContext();
    const { user: loginUser } = useContext(AuthContext);
    useEffect(() => {
        let tId = searchParams.get("id");
        if (tId != null) {
            let uId = parseInt(tId);
            if (uId > 0) {
                setLoading(true);
                let g = allRoleGroups.find((x) => x.roleGroupID == uId);
                setSelectedRow(g);
                setLoading(false);
            }
            else {
                setSelectedRow({
                    roleGroupID: 0,
                    roleGroupName: "",
                    roleGroupDescription: "",
                    roleIDS: "",
                    createdBy: loginUser.userID,
                    createdAt: null
                })
            }
        }
        else
            setSelectedRow(undefined)
    }, [searchParams])

    return (
        loading ? <LoadingOverlay msg={`Loading ${LabelConstants.RoleGroups}`} /> :
            typeof selectedRow != 'undefined' ?
                <RoleGroupEditor group={selectedRow} onClose={(refresh) => {
                    navigate("/rolegroups");
                }} fromGroup={true} /> :
                <RoleGroupsManager />
    )
}

export default RoleGroupWrapper;